module.exports = __webpack_public_path__ + "static/media/appBanner.308ae549.png";